var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"page-title",on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.news.back')))]),_c('div',{staticClass:"ql-container ql-editor",staticStyle:{"padding":"0px 16px 16px 16px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }